module.exports = __webpack_public_path__ + "7af8048784dfaafb905704d1f847dfb0.MP3";